const PencilIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" {...props}>
        <path
            fill={props.fill ?? '#fff'}
            d="M12.765 3.201 9.86.297a1.04 1.04 0 0 0-1.471 0L.374 8.312a1.031 1.031 0 0 0-.305.736v2.904a1.04 1.04 0 0 0 1.04 1.04h10.92a.52.52 0 0 0 0-1.04H5.485l7.28-7.28a1.042 1.042 0 0 0 0-1.47Zm-8.751 8.751H1.109V9.048l5.72-5.72 2.905 2.904-5.72 5.72Zm6.455-6.455L7.565 2.592l1.56-1.56 2.904 2.905-1.56 1.56Z"
        />
    </svg>
)
export default PencilIcon
